import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSchoolsForAdmin } from "../../actions/schoolActions";
import { Input, Button, Row, Col } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddProgramLicenseToSchoolModal from "../../components/ProgramLicense/AddProgramLicenseToSchooModall";
import NumberOfLicenses from "../../components/ProgramLicense/NumberOfLicensesTable";
import NumberFormat from "react-number-format";
import LicensesDetails from "../../components/ProgramLicense/LicensesDetails";
import { FormattedMessage } from "react-intl";
import { saveAs } from "file-saver";
import SuperuserSchoolEditModal from "../../components/Modal/SuperuserSchoolEditModal";
import CreateNewSchoolWizardModal from "../../components/Modal/CreateNewSchoolWizardModal";
import SchoolsTable from "./SchoolsTable";
import EditGroupsModal from "../../components/Modal/EditGroupsModal";

class SuperUser extends Component {
  state = {
    filterSearch: "",
    addSchoolModal: false,
    overrideLoader: false,
    schoolToUpdate: null,
    licenseModalState: false,
    currentSchool: null,
    selectedProgramlicensesToAdd: [],
    availabledProgramLicenses: [],
    collapsedLicenses: [],
    toggledLicenseDetails: [],
    editSchool: false,
    editGroupsModalIsOpen: false,
  };

  componentDidMount() {
    this.props.dispatch(fetchSchoolsForAdmin());
  }

  toggleAddSchoolModal = (school) => {
    this.setState({ overrideLoader: true });
    this.setState({ schoolToUpdate: school });
    this.setState({ addSchoolModal: !this.state.addSchoolModal });
  };
  toggleEditSchoolModal = (school) => {
    this.setState({ overrideLoader: true });
    this.setState({ schoolToUpdate: school });
    this.setState({ editSchool: !this.state.editSchool });
  };

  updateSchools = () => {
    this.props.dispatch(fetchSchoolsForAdmin());
    this.setState({ addSchoolModal: false });
  };

  toggleProgramLicensesModal = (show, school) => {
    this.setState({ licenseModalState: show, currentSchool: school });
  };

  filterSearch = (event) => {
    this.setState({ filterSearch: event.target.value });
  };
  handleChangeSelect = (selected) => {
    this.setState({ selectedProgramlicensesToAdd: selected });
  };
  toggleCollapse = (id) => {
    let collapsed = this.state.collapsedLicenses;

    var index = collapsed.indexOf(id);
    if (index !== -1) collapsed.splice(index, 1);
    else collapsed.push(id);

    this.setState({ collapsedLicenses: collapsed });
  };

  toggleLicenseDetails = (detail, license) => {
    this.setState({ toggledLicenseDetails: [detail, license] });
  };

  closeLicenseDetails = () => {
    this.setState({ toggledLicenseDetails: [] });
  };

  render() {
    if (this.props.schoolInformation.loading && !this.state.overrideLoader) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }
    var schools = this.props.schoolInformation.schoolResult.schools;

    var fnSchoolsExcelReport = function () {
      var tab_text =
        '<table><tr style="font-weight:bold"><td>Kundnummer</td><td>Namn</td><td>Adress</td><td>Postnummer</td><td>Stad</td><td>Land</td><td>Programlicenser</td><td>Program</td><td>Klasser</td><td>Lärare</td>' +
        "<td>Elever</td><td>ElLicens</td><td>ByggLicens</td><td>FordonLicens</td><td>StudenterEl</td><td>StudenterBygg</td><td>StudenterFordon</td></tr>";
      schools.map((s) => {
        return (tab_text +=
          "<tr>" +
          '<td style="text-align:left">' +
          s.fortKnoxCustomerNumber +
          '</td><td style="white-space:nowrap">' +
          s.name +
          '</td><td style="white-space:nowrap">' +
          s.adress.street +
          '</td><td style="text-align:left">' +
          s.adress.zipCode +
          "</td><td>" +
          s.adress.city +
          "</td><td>" +
          s.adress.country +
          '</td><td style="text-align:right">' +
          s.programLicenses.length +
          '</td><td style="text-align:right">' +
          s.programmes.length +
          '</td><td style="text-align:right">' +
          s.nbrOfClasses +
          '</td><td style="text-align:right">' +
          s.nbrOfTeachers +
          '</td><td style="text-align:right">' +
          s.nbrOfStudents +
          '</td><td style="text-align:center">&nbsp;' +
          s.licenseEl +
          '</td><td style="text-align:center">&nbsp;' +
          s.licenseBygg +
          '</td><td style="text-align:center">&nbsp;' +
          s.licenseFordon +
          '</td><td style="text-align:right">' +
          s.studenterEl +
          '</td><td style="text-align:right">' +
          s.studenterBygg +
          '</td><td style="text-align:right">' +
          s.studenterFordon +
          "</td></tr>");
      });
      tab_text = tab_text + "</table>";
      var data = new Blob(["\ufeff", tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        encoding: "utf-8",
      });
      saveAs(data, "Schools.xls");
    };

    if (this.state.filterSearch.length > 0) {
      schools = this.props.schoolInformation.schoolResult.schools.filter(
        (school) => {
          if (
            school.name
              .toLowerCase()
              .indexOf(this.state.filterSearch.toLowerCase()) !== -1 ||
            school.fortKnoxCustomerNumber
              .toLowerCase()
              .indexOf(this.state.filterSearch.toLowerCase()) !== -1 ||
            (school.adress.street != null &&
              school.adress.street
                .toLowerCase()
                .indexOf(this.state.filterSearch.toLowerCase()) !== -1) ||
            (school.adress.zipCode != null &&
              school.adress.zipCode
                .toLowerCase()
                .indexOf(this.state.filterSearch.toLowerCase()) !== -1) ||
            (school.adress.city != null &&
              school.adress.city
                .toLowerCase()
                .indexOf(this.state.filterSearch.toLowerCase()) !== -1) ||
            (school.group != null &&
              school.group.name
                .toLowerCase()
                .indexOf(this.state.filterSearch.toLowerCase()) !== -1)
          ) {
            return school;
          }
          return null;
        }
      );
    }

    return (
      <div>
        <div className="card card-body">
          <h4>
            <FormattedMessage id="Navigation_Superuser_Schools" />
          </h4>
          <h6 className="text-muted mb-0">
            <FormattedMessage id="SchoolsTotal" />
            <NumberFormat
              value={this.props.schoolInformation.schoolResult.quantitySchools}
              displayType={"text"}
              thousandSeparator={" "}
            />{" "}
            <FormattedMessage id="PiecesShort" />{" "}
            <FormattedMessage id="StudentsTotal" />
            <NumberFormat
              value={this.props.schoolInformation.schoolResult.quantityStudents}
              displayType={"text"}
              thousandSeparator={" "}
            />{" "}
            <FormattedMessage id="PiecesShort" />
          </h6>
        </div>

        <div className="container-fluid admin-container pb-0">
          <NumberOfLicenses
            programLicenses={this.props.schoolInformation.schoolResult.licenses}
            toggleLicenseDetails={this.toggleLicenseDetails}
          />
        </div>

        <LicensesDetails
          closeDetails={this.closeLicenseDetails}
          showLicenseDetails={this.state.toggledLicenseDetails.length > 0}
          schools={this.props.schoolInformation.schoolResult.schools}
          selectedLicenseDetail={this.state.toggledLicenseDetails}
        />

        <div className="container-fluid admin-container">
          <Row className="search-row">
            <Col className="col-3">
              <Input
                className="search-input"
                placeholder="Sök skola"
                onChange={this.filterSearch.bind(this)}
              />
            </Col>
            <Col lg={6}>
              <Button
                className="me-2"
                color="primary"
                outline
                onClick={() => this.setState({ editGroupsModalIsOpen: true })}
              >
                Redigera grupper
              </Button>

              <Button
                className="me-2"
                color="primary"
                outline
                onClick={fnSchoolsExcelReport}
              >
                <FormattedMessage id="ExportToXls" />
              </Button>

              <Button
                color="primary"
                outline
                onClick={() => {
                  this.toggleAddSchoolModal(null);
                }}
              >
                <FontAwesomeIcon icon="plus" />
              </Button>
            </Col>
          </Row>
          <SchoolsTable
            schools={schools}
            toggleEditSchoolModal={this.toggleEditSchoolModal}
            toggleProgramLicensesModal={this.toggleProgramLicensesModal}
            history={this.props.history}
          />
        </div>

        <CreateNewSchoolWizardModal
          toggle={() => this.toggleAddSchoolModal(null)}
          isOpen={this.state.addSchoolModal}
        />
        <SuperuserSchoolEditModal
          schoolToUpdate={this.state.schoolToUpdate}
          updateSchools={this.updateSchools}
          isOpen={this.state.editSchool}
          toggle={() => this.toggleEditSchoolModal(null)}
        />
        <AddProgramLicenseToSchoolModal
          key={this.state.currentSchool ? this.state.currentSchool.id : 0}
          isOpen={this.state.licenseModalState}
          toggle={this.toggleProgramLicensesModal}
          school={this.state.currentSchool}
        />
        <EditGroupsModal
          isOpen={this.state.editGroupsModalIsOpen}
          close={() => this.setState({ editGroupsModalIsOpen: false })}
          schools={schools}
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    schoolInformation: store.schoolReducer,
  };
};

export default connect(mapStateToProps)(SuperUser);
